__turbopack_context__.v({
  "avatar": "KBKOhq_avatar",
  "image": "KBKOhq_image",
  "large": "KBKOhq_large",
  "medium": "KBKOhq_medium",
  "slideInAnimation": "KBKOhq_slideInAnimation",
  "small": "KBKOhq_small",
});
